import React from "react";
import PropTypes from "prop-types";

import Grid from "@material-ui/core/Grid";

import BodyText from "core/BodyText";
import * as appColors from "core/colors";

import { isTransparent } from "./helpers";

import { ContainerGrid, Swatch } from "./styles";

const Swatches = ({ colors, onSwatchClick, title, swatchTestId }) => {
    const normalizeColors = colors.map(color => {
        if (isTransparent(color)) {
            return "None";
        } else {
            return color.toLowerCase();
        }
    });

    return (
        <ContainerGrid container alignItems="center">
            <BodyText type="p" size="xs" copyColor={appColors.default.midnight}>
                {title}
            </BodyText>

            <Grid container>
                {normalizeColors.map((color, idx) => (
                    <Swatch
                        type="button"
                        aria-label={`Hex Code ${color}`}
                        key={idx}
                        color={color}
                        onClick={() => onSwatchClick(color)}
                        data-testid={swatchTestId}
                    />
                ))}
            </Grid>
        </ContainerGrid>
    );
};

Swatches.propTypes = {
    colors: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired,
    title: PropTypes.string.isRequired,
    onSwatchClick: PropTypes.func.isRequired
};

export default Swatches;
